import React from "react";
import { cn } from "./utils";

export default function DataTable({ children, className = "" }) {
  return (
    <div className={cn("overflow-x-auto", className)}>
      <table className="w-full text-sm">{children}</table>
    </div>
  );
}

export function DataTableHead({ children, className = "" }) {
  return <thead className={cn("bg-slate-50", className)}>{children}</thead>;
}

export function DataTableRow({ children, className = "" }) {
  return <tr className={cn("border-b border-slate-200 align-top", className)}>{children}</tr>;
}

export function DataTableCell({ children, className = "", header = false, ...props }) {
  const Component = header ? "th" : "td";
  return (
    <Component
      className={cn(
        header
          ? "px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600"
          : "px-3 py-2 text-slate-800",
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
}
